import React from "react";

function ShareBtnSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      fill="none"
      viewBox="0 0 33 33"
    >
      <g filter="url(#filter0_d_2688_41080)">
        <rect width="29" height="29" x="2" y="1" fill="#fff" rx="5.8"></rect>
        <path
          stroke="#344054"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.16"
          d="M14.523 16.376l3.961 2.308m-.006-6.368l-3.955 2.308m7.198-3.184a1.74 1.74 0 11-3.48 0 1.74 1.74 0 013.48 0zm-6.96 4.06a1.74 1.74 0 11-3.48 0 1.74 1.74 0 013.48 0zm6.96 4.06a1.74 1.74 0 11-3.48 0 1.74 1.74 0 013.48 0z"
        ></path>
        <rect
          width="28.275"
          height="28.275"
          x="2.362"
          y="1.363"
          stroke="#D0D5DD"
          strokeWidth="0.725"
          rx="5.438"
        ></rect>
      </g>
      <defs>
        <filter
          id="filter0_d_2688_41080"
          width="31.9"
          height="31.9"
          x="0.55"
          y="0.275"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="0.725"></feOffset>
          <feGaussianBlur stdDeviation="0.725"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2688_41080"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2688_41080"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default ShareBtnSvg;
